module.exports = __webpack_public_path__ + "lp/img/recording_active.2ea0413a.svg";